import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation  } from "react-router-dom";
import BackButton from "../../../components/BackButton";
import Calendar from "./Calendar";
import TimeAndSeat from "./TimeAndSeat";
import Checkout from "./CheckoutSummary";
import "../../../styles/GetTicket.scss";
import { FaCalendar as FaCalendarRaw } from "react-icons/fa";
import { FaLocationDot as FaLocationDotRaw } from "react-icons/fa6";
import { IoPerson as IoPersonRaw } from "react-icons/io5";
import { tryFetch, IResponse } from "../../../helpers/FetchAPI";
import { getTokenOrDefault } from "../../../helpers/Storage";
import { useEventRating } from "../../hooks/useEventRating";

const GetTicketPage: React.FC = () => {
  // const { id } = useParams();
  const { slug } = useParams();
  const navigate = useNavigate();
  const [eventData, setEventData] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  const [selectedTicketType, setSelectedTicketType] = useState<string | null>(null);
  const formattedRating = useEventRating(eventData?.event_rating || "");
  const location = useLocation();
  const eventId = location.state?.eventId;
  const [selectedSeatIds, setSelectedSeatIds] = useState<string[]>([]);


  useEffect(() => {
  const fetchEvent = async () => {
    try {
      if (!eventId) {
        console.error("Event ID not found from navigation state.");
        setEventData(null);
        return;
      }

      const res: IResponse = await tryFetch({
        url: `/events/${eventId}`,
        method: "GET",
      });

      if (res.is_success && res.data) {
        const foundEvent = res.data as any;

        const mappedEvent = {
          id: foundEvent.id,
          event_title: foundEvent.event_title,
          venue: foundEvent.venue,
          event_rating: foundEvent.event_rating,
          description: foundEvent.description,
          organizer: foundEvent.organizer,
          dates: foundEvent.all_dates || [],
          is_seat_section: foundEvent.is_seat_section,
          tickets: (foundEvent.tickets || []).map((t: any) => ({
            id: t.id,
            ticket_type: t.name,
            price: t.ticket_price,
            available_slot: t.capacity.toString(),
            seats: [],
          })),
          house_rules: foundEvent.house_rules || [],
        };

         setEventData(mappedEvent);
      } else {
        console.error("Failed to fetch event:", res.error);
        setEventData(null);
      }
    } catch (error) {
      console.error("Error fetching event:", error);
      setEventData(null);
    }
  };

  fetchEvent();
}, [eventId, slug]);

const formatEventDateRange = (dates: string[]) => {
  if (!dates || dates.length === 0) return "No Dates";

  const sortedDates = [...dates].sort(
    (a, b) => new Date(a).getTime() - new Date(b).getTime()
  );

  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });

  const startDate = formatDate(sortedDates[0]);
  const endDate = formatDate(sortedDates[sortedDates.length - 1]);

  return startDate === endDate ? startDate : `${startDate} - ${endDate}`;
};

  const handleProceed = async (
    ticketId: string,
    ticketCount: number,
    selectedDate: string | null,
    selectedTime: string | null
  ) => {
    if (!ticketId || !selectedDate || !selectedTime) {
      alert("Please select ticket, date, and time first.");
      return;
    }

    const token = getTokenOrDefault();
    const formattedDate = `${selectedDate}`;

    const payload = {
      ticket_type_id: ticketId,
      ticket_count: ticketCount.toString(),
      selected_dates: [formattedDate],
    };

    try {
      const res: IResponse = await tryFetch({
        url: `/sec/events/${eventData.id}/tickets/${ticketId}`,
        method: "POST",
        token,
        payload,
      });

      if (res.is_success) {
        const createdTicketId: string = (res.data as any)?.id || ticketId;
        navigate(`/preview/${createdTicketId}`);
      } else {
        alert("Checkout failed: " + res.error);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    }
  };

  if (!eventData) return <div>Loading...</div>;

  const FaCalendar = FaCalendarRaw as React.ElementType;
  const FaLocationDot = FaLocationDotRaw as React.ElementType;
  const IoPerson = IoPersonRaw as React.ElementType;

  return (
    <div className="get-ticket">
      <BackButton />
      <h1 className="page-title">Get Tickets</h1>
      <hr className="divider" />

      <div className="event-details">
        <h2>{eventData.event_title}</h2>
        <p className="e-organizer">by {eventData.organizer}</p>
        <p>
          <FaCalendar className="icon" />
          {/* {" "} */}
          {formatEventDateRange(eventData.dates)}
          {/* {eventData.dates.length
      ? eventData.dates
          .map((d: string) =>
            new Date(d).toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
              year: "numeric",
            })
          )
          .join(", ")
      : "No Dates"} */}
  </p>
        <p>
          <FaLocationDot className="icon" /> {eventData.venue}
        </p>
        <p>
          <IoPerson className="icon" /> {formattedRating}
        </p>
      </div>

      <TimeAndSeat
        tickets={eventData.tickets}
        availableDates={eventData.dates}
         isSeatSection={eventData.is_seat_section === "1" || eventData.is_seat_section === true}
        onDateSelect={setSelectedDate}
        onTimeSelect={setSelectedTime}
        onTicketSelect={setSelectedTicketType}
      />

      <Checkout
        tickets={eventData.tickets}
        eventData={eventData}
        selectedDate={selectedDate}
        selectedTime={selectedTime}
        selectedTicketType={selectedTicketType}
         isSeatSection={eventData.is_seat_section === "1" || eventData.is_seat_section === true}
        onProceed={handleProceed}
      />
    </div>
  );
};

export default GetTicketPage;
